import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from './translations/en.json';
import es from './translations/es.json';
import fr from './translations/fr.json';

// Recursively replace all leaf string values with `string` so that es/fr
// satisfies this shape without needing identical literal values.
type DeepStringify<T> = T extends string
  ? string
  : T extends readonly (infer U)[]
    ? readonly DeepStringify<U>[]
    : { [K in keyof T]: DeepStringify<T[K]> };

type TranslationShape = DeepStringify<typeof en>;

export const resources = {
  en: { translation: en },
  // satisfies enforces that es/fr always have every key present in en.json.
  // A TypeScript error here means a translation file is missing keys.
  es: { translation: es satisfies TranslationShape },
  fr: { translation: fr satisfies TranslationShape },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // Check localStorage first so manual in-app language selection is
      // respected, then fall back to browser/OS language settings.
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'coast-language',
      caches: ['localStorage'],
    },
  })
  .catch(e => {
    console.error('i18n init error', e);
  });
